// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3-ZL5","productName":"Table_productName__2CUZ4"};